var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"ivu-tabs-tabpane",style:(_vm.contentStyle)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }